module.exports = __webpack_public_path__ + "static/media/system-shutdown-symbolic.106b7c9b.svg";